/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Private_Models_Form_Vllm_Model_Name_PlaceholderInputs */



/**
* | output |
* | --- |
* | "meta-llama/Meta-Llama-3-70B-Instruct" |
*
* @param {Private_Models_Form_Vllm_Model_Name_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const private_models_form_vllm_model_name_placeholder = /** @type {((inputs?: Private_Models_Form_Vllm_Model_Name_PlaceholderInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Private_Models_Form_Vllm_Model_Name_PlaceholderInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("meta-llama/Meta-Llama-3-70B-Instruct")
	return /** @type {LocalizedString} */ ("meta-llama/Meta-Llama-3-70B-Instruct")
});